import React from "react";
import Modal from "./index";

export default function GoBackModal({ show, onClose, goBack, strikes }) {
    return (
        <Modal show={show} onClose={onClose}>
            <h1>Go back?</h1>
            <p>
                Going back counts as a strike.
            </p>
            <p>
                All moves after this point will be removed.
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <button
                    style={{
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '5px',
                        color: 'white',
                        cursor: 'pointer',
                        backgroundColor: '#e53935'
                    }}
                    onClick={() => {
                        goBack();
                    }}
                    disabled={strikes.length >= 2}
                >
                    Go Back
                </button>
                <button
                    style={{
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '5px',
                        color: 'white',
                        cursor: 'pointer',
                        backgroundColor: '#555'
                    }}
                    onClick={onClose}
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
}